import { Outlet } from "react-router";

import { useCurrentRoute } from "./useCurrentRoute";

// Render an `Outlet` router component only if the current location is a modal, avoiding
// non-modal sub-routes to render where they shouldn't
//
const ModalOutlet = () => {
  const { isModal } = useCurrentRoute();

  if (!isModal) return null;

  return <Outlet />;
};

export default ModalOutlet;
